import 'idempotent-babel-polyfill';

import * as React from "react";
import ReactDOM from 'react-dom';
import App from './App';

const mountElement = document.querySelector('[data-react-findinstore]');

if (mountElement) {
    ReactDOM.render((<App/>), mountElement);
}
